export default __webpack_public_path__ + "static/media/526.c8f8110d.gif";